export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Página no encontrada',
    description: 'La página que busca no existe',
    goBack: 'Volver al inicio',
  },
  common: {
    loading: 'Cargando...',
    noData: 'Sin datos disponibles',
    error: 'Algo salió mal, por favor reintente',
    retry: 'Reintentar',
    authExpired: 'Sesión expirada, inicie sesión de nuevo',
    requestFailed: 'Solicitud fallida',
    networkError: 'Error de red, verifique su conexión',
    skipToContent: 'Ir al contenido principal',
  },
  nav: {
    dashboard: 'Panel',
    visa: 'Visado',
    cost: 'Costo',
    timezone: 'Zona horaria',
    tax: 'Impuestos',
    guide: 'Guía',
    login: 'Iniciar sesión',
  },
  footer: {
    about: 'Acerca de',
    privacy: 'Privacidad',
    terms: 'Términos',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Tu vida nómada digital, organizada',
      subtitle: 'Plataforma integral de seguimiento de visados, comparación de costos, coordinación de zonas horarias, cumplimiento fiscal y guías de ciudades',
      cta: 'Comenzar gratis',
      learnMore: 'Más información',
    },
    features: {
      title: 'Funcionalidades',
      visa: { title: 'Seguimiento de visado', desc: 'Rastree tipos de visado, validez y recordatorios de renovación' },
      cost: { title: 'Comparar costos', desc: 'Compare costos de vida: alojamiento, alimentación, transporte y más' },
      timezone: { title: 'Gestión de zonas', desc: 'Relojes multizona y coordinación de reuniones entre zonas horarias' },
      tax: { title: 'Asistente fiscal', desc: 'Consulta de reglas fiscales transfronterizas y alertas de residencia' },
      guide: { title: 'Guía de ciudades', desc: 'Guías detalladas de destinos nómadas digitales en el mundo' },
    },
    stats: {
      countries: 'Países',
      cities: 'Ciudades',
      languages: 'Idiomas',
    },
  },
  login: {
    login: 'Iniciar sesión',
    register: 'Registrarse',
    subtitle: 'Inicie sesión en NomadMate para gestionar su vida nómada',
    registerSubtitle: 'Cree una cuenta para comenzar su vida nómada digital',
    email: 'Correo electrónico',
    emailPlaceholder: 'su@email.com',
    emailInvalid: 'Ingrese un correo electrónico válido',
    username: 'Nombre de usuario',
    usernamePlaceholder: 'Ingrese su nombre de usuario',
    password: 'Contraseña',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
    confirmPassword: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Vuelva a ingresar la contraseña',
    passwordMismatch: 'Las contraseñas no coinciden',
    loading: 'Iniciando sesión...',
    error: 'Error al iniciar sesión, intente de nuevo',
    orContinueWith: 'O continúe con',
    noAccount: '¿No tiene cuenta?',
    hasAccount: '¿Ya tiene cuenta?',
  },
  dashboard: {
    welcome: 'Bienvenido de nuevo, {name}',
    subtitle: 'Resumen de su vida nómada',
    stats: {
      activeVisas: 'Visados activos',
      daysUntilExpiry: 'Días hasta vencimiento',
      citiesCompared: 'Ciudades comparadas',
      timezones: 'Zonas horarias seguidas',
    },
    expiryAlerts: 'Alertas de vencimiento de visado',
    noAlerts: 'Sin alertas de vencimiento',
    daysLeft: '{days} días restantes',
    worldClocks: 'Relojes mundiales',
    quickActions: 'Acciones rápidas',
    actions: {
      visa: 'Seguimiento visado',
      cost: 'Comparar costos',
      timezone: 'Zonas horarias',
      tax: 'Asistente fiscal',
      guide: 'Guía ciudades',
    },
    recentActivity: 'Actividad reciente',
    noActivity: 'Sin actividad reciente',
  },
  visa: {
    title: 'Gestión de visados',
    subtitle: 'Rastree y gestione su información de visado',
    searchPlaceholder: 'Buscar por país...',
    allRegions: 'Todas las regiones',
    regions: {
      europe: 'Europa',
      asia: 'Asia',
      americas: 'Américas',
      oceania: 'Oceanía',
    },
    noCountries: 'No se encontraron países',
    requirements: 'Requisitos',
    documents: 'Documentos requeridos',
    track: 'Rastrear este visado',
    applyUrl: 'Enlace de solicitud',
    myTracked: 'Mis visados rastreados',
  },
  cost: {
    title: 'Costo de vida',
    subtitle: 'Compare el costo de vida entre diferentes ciudades',
    selectCities: 'Seleccionar ciudades',
    selectHint: 'Seleccione 2-4 ciudades para comparar',
    compare: 'Comparar',
    selectedCount: '{count} ciudades seleccionadas',
    comparison: 'Comparación',
    category: 'Categoría',
    nomadScore: 'Puntuación nómada',
    budgetFinder: 'Buscador de presupuesto',
    budgetPlaceholder: 'Ingrese presupuesto mensual',
    findCities: 'Buscar ciudades',
    aiSuggestion: 'Sugerencias IA próximamente',
  },
  timezone: {
    title: 'Gestión de zonas horarias',
    subtitle: 'Gestione horarios y reuniones en múltiples zonas',
    addTimezone: 'Agregar zona horaria',
    noTimezones: 'Haga clic arriba para agregar zonas horarias',
    meetingScheduler: 'Planificador de reuniones',
    meetingHint: 'Seleccione las zonas horarias de los participantes para encontrar el mejor horario',
    findMeeting: 'Buscar horario de reunión',
    finding: 'Buscando...',
    bestTime: 'Mejor horario',
    workingOverlap: 'Superposición horario laboral',
  },
  tax: {
    title: 'Asistente fiscal',
    subtitle: 'Cálculo fiscal transfronterizo y cumplimiento',
    rules: 'Reglas fiscales',
    selectCountry: 'Seleccionar país',
    thresholdDays: 'Días umbral de residencia',
    days: 'días',
    taxRates: 'Tasas impositivas',
    reportingRequirements: 'Obligaciones de declaración',
    importantDates: 'Fechas importantes',
    residenceTracker: 'Seguimiento de días de residencia',
    noResidenceDays: 'Sin días de residencia registrados',
    riskIndicator: 'Indicador de riesgo fiscal',
    noRiskData: 'Sin datos de riesgo disponibles',
    countries: {
      portugal: 'Portugal',
      thailand: 'Tailandia',
      spain: 'España',
      germany: 'Alemania',
      estonia: 'Estonia',
      georgia: 'Georgia',
      croatia: 'Croacia',
      mexico: 'México',
      colombia: 'Colombia',
      indonesia: 'Indonesia',
      japan: 'Japón',
      southKorea: 'Corea del Sur',
      unitedKingdom: 'Reino Unido',
      unitedStates: 'Estados Unidos',
    },
  },
  guide: {
    title: 'Guía de ciudades',
    subtitle: 'Guías de destinos nómadas digitales en el mundo',
    allContinents: 'Todos',
    noCities: 'No se encontraron ciudades',
    backToList: 'Volver a la lista',
    internetQuality: 'Calidad de Internet',
    safetyRating: 'Calificación de seguridad',
    climate: 'Clima',
    communitySize: 'Tamaño de comunidad',
    coworkingSpaces: 'Espacios de coworking',
    noCoworking: 'Sin espacios de coworking disponibles',
    day: 'día',
  },
  settings: {
    title: 'Configuración',
    subtitle: 'Gestione su cuenta y preferencias',
    profile: 'Perfil',
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    saveProfile: 'Guardar perfil',
    saving: 'Guardando...',
    language: 'Idioma',
    notifications: 'Notificaciones',
    visaExpiryNotif: 'Recordatorios de vencimiento de visado',
    taxReminderNotif: 'Recordatorios fiscales',
    appearance: 'Apariencia',
    light: 'Claro',
    dark: 'Oscuro',
    baseTimezone: 'Zona horaria base',
    dangerZone: 'Zona de peligro',
    dangerDesc: 'Estas acciones son irreversibles, proceda con precaución',
    deleteAccount: 'Eliminar cuenta',
    confirmDelete: 'Confirmar eliminación de cuenta',
    confirmDeleteDesc: 'Esto eliminará permanentemente su cuenta y todos sus datos. Esta acción no se puede deshacer.',
    cancel: 'Cancelar',
    confirm: 'Eliminar',
  },
  about: {
    title: 'Acerca de',
    subtitle: 'NomadMate - Asistente de vida nómada digital',
    version: 'Versión',
    versionNumber: '1.0.0',
    description: 'NomadMate es un asistente diseñado para nómadas digitales, que ofrece gestión de visados, comparación de costos de vida, gestión de zonas horarias, cálculo fiscal y guías de ciudades para facilitar su vida nómada global.',
    openSource: 'Agradecimientos open source',
    openSourceDesc: 'Este proyecto está construido sobre los siguientes excelentes proyectos open source',
    contact: 'Contáctenos',
    support: 'Soporte técnico',
    feedback: 'Comentarios',
    privacyPolicy: 'Política de privacidad',
    terms: 'Términos de servicio',
  },
}
